(function () {

    'use strict';

    angular
        .module('app.search')
        .factory('BreadcrumbService', [
            '$q',
            'DataService',
            '$filter',
            BreadcrumbService
        ]);

    function BreadcrumbService($q, dataService, $filter) {

        var service = {};
        service.getSetConditions = getSetConditions;
        service.rangedConditionDisplayFormatter = rangedConditionDisplayFormatter;

        return service;

        function rangedConditionDisplayFormatter(value, format) {
            if (!format) format = function (v) {
                return v
            };
            var l = value.getLower();
            var u = value.getUpper();
            if (l === undefined || l === null)
                return (dataService.getCurrentTranslation()['searchBreadCrumbUpTo'] + " " + format(u));
            else if (u === undefined || u === null)
                return ( format(l) + " " + dataService.getCurrentTranslation()['searchBreadCrumbOnwards']);
            else
                return (format(l) + dataService.getCurrentTranslation()['searchBreadCrumbTo'] + format(u));
        }

        function simpleConditionDisplayFormatter(value, searchResult, condName, format) {

            if (!format) format = function (v) {
                return v
            };

            var v = value.getValue();

            if (typeof v === "string") v = [v];

            var ellipses;

            if (v.length > 1) ellipses = function (v) {
                return v + "..."
            };
            else ellipses = function (v) {
                return v
            };

            var appValues = searchResult.getApplicableConditionValues();

            v = v[0];

            if (appValues[condName]) {

                var name = findName(v, appValues[condName]['enum']);

                if (name === undefined || name === null) {
                    name = findName(v, appValues[condName]['data']);
                }
                if (!(name === undefined || name === null)) v = name;
            }

            function findName(id, data) {

                if (data) for (var ind in data) if (data.hasOwnProperty(ind)) {
                    if (data[ind].id == id) {
                        return data[ind].name;
                    }
                }

                return undefined;
            }

            if(name === undefined || name === null){
                v = null;
            }else{
                v = ellipses(v);
            }

            return v;
        }

        function getSetConditions(searchResult, conditionNameFilter, conditionDisplayFormatters) {
            if (!conditionNameFilter) conditionNameFilter = function () {
                return true
            };

            var setCondValues = searchResult.getSearchContext().getConditionValues();
            var values = [];
            for (var condName in setCondValues) if (setCondValues.hasOwnProperty(condName) && conditionNameFilter(condName)) {

                var setCondValue = setCondValues[condName];


                var value;
                var setAction;

                if (conditionDisplayFormatters[condName]) {
                    value = conditionDisplayFormatters[condName](setCondValue);
                    if (setCondValue.isRangeValue()) setAction = function (searchContext) {};
                    addConditionAndValue(values, condName, value);
                }
                else if (setCondValue.isRangeValue()) {
                    value = rangedConditionDisplayFormatter(setCondValue);
                    if (condName == 'grdr' && (value == '-1 to 5.0' || value == '-1 à 5.0')) {

                    } else {
                        addConditionAndValue(values, condName, value);
                    }
                } else {

                    if (condName == 'pao' && setCondValue.getValue().length > 1) {

                    } else {
                        value = simpleConditionDisplayFormatter(setCondValue, searchResult, condName);
                        addConditionAndValue(values, condName, value);
                    }
                }
            }

            return values;
        }

        function addConditionAndValue(values, condName, value) {

            if(value != null) {
                if (condName == 'lbln') {
                    value = dataService.getCurrentTranslation()['search.lane'] + ' : ' + value;
                }

                if (condName == 'rlad') {
                    value = $filter('date')(value, "MM-dd-yy");
                }

                if (condName == 'grdr') {
                    value = dataService.getCurrentTranslation()['searchGrade'] + ' : ' + value.replace(/-1/g, "Not specified");
                }

                values.push({
                    "name": condName,
                    "display": value
                });
            }
        }
    }

})();


// WEBPACK FOOTER //
// ./app/search/components/service/BreadcrumbService.js